/**
 * Jämförelse av mjukvarunamn.
 *
 * "BIM 360", "BIM360" och "bim 360" är samma mjukvara: stora och små
 * bokstäver och mellanslag spelar ingen roll. Lagrade namn skrivs aldrig om –
 * nyckeln används bara för att jämföra och slå ihop vid visning.
 */

export const softwareKey = name => String(name || '').toLowerCase().replace(/\s+/g, '');

/** Tar bort varianter av samma namn. Den första förekomsten behålls. */
export function dedupeSoftware(names) {
  const seen = new Set();
  const out = [];
  (names || []).forEach(raw => {
    const name = String(raw || '').trim();
    const key = softwareKey(name);
    if (!key || seen.has(key)) return;
    seen.add(key);
    out.push(name);
  });
  return out;
}

/** true om listan redan innehåller en variant av namnet. */
export const hasSoftware = (names, name) => {
  const key = softwareKey(name);
  return (names || []).some(n => softwareKey(n) === key);
};
